import { useFiltersStore } from '@/lib/store/filters-store'
import { useQuery } from '@tanstack/react-query'
import { MeilisearchAssetRepository } from '@/lib/assets/repositories/meilisearch-asset-repository'
import { useEffect } from 'react'

/**
 * This hook is responsible to synchronize the available keywords for a given
 * set of categories and filters.
 */
export default function useSyncAvailableKeywords({
  enabled = true,
  mainCategorySlug,
  categorySlug,
  subCategorySlug,
  contentSlug,
  search,
  premium,
}: {
  enabled?: boolean
  mainCategorySlug?: string
  categorySlug?: string
  subCategorySlug?: string
  contentSlug?: string
  search?: string
  premium?: boolean
}) {
  const setAvailableKeywords = useFiltersStore((state) => state.setAvailableKeywords)

  const { data: keywords } = useQuery({
    queryKey: ['keywords', { mainCategorySlug, categorySlug, subCategorySlug, contentSlug, search, premium }],
    queryFn: async () => {
      const assetRepository = new MeilisearchAssetRepository()
      return await assetRepository.getFacets({
        mainCategorySlug,
        categorySlug,
        subCategorySlug,
        contentSlug,
        search,
        premium,
      })
    },
    enabled: enabled && !!mainCategorySlug,
  })

  useEffect(() => {
    if (!keywords) {
      return
    }
    setAvailableKeywords(keywords)
  }, [keywords, setAvailableKeywords])

  return { keywords }
}
